import BaseEntity from "../../AbstractEntities/BaseEntity";
import constraints from "./constraints";
import migrate from "./migrate";
export default class InstantPackage extends BaseEntity {
    constructor(data = {}) {
        super(migrate(data), constraints);
    }
    get baseUrl() {
        return `${super.baseUrl}/suppliers/${this.supplierId}/instant-packages/${this.id}`;
    }
    get data() {
        const parent = super.data;
        const { supplierId, name, platform, tariffs, hardwareFunds, leasing, roaming, customerService, published, isTariffShown, } = this;
        const { version } = this._data;
        return {
            ...parent,
            version,
            supplierId,
            name,
            platform,
            tariffs,
            hardwareFunds,
            leasing,
            roaming,
            customerService,
            published,
            isTariffShown,
        };
    }
    get toSave() {
        const { seqNo, ...data } = this.data;
        return data;
    }
    get links() {
        return {
            self: `${this.baseUrl}`,
        };
    }
    get supplierId() {
        return this._data.supplierId;
    }
    get name() {
        return this._data.name;
    }
    get platform() {
        return this._data.platform;
    }
    get tariffs() {
        return this._data.tariffs;
    }
    get hardwareFunds() {
        return this._data.hardwareFunds;
    }
    get leasing() {
        return this._data.leasing;
    }
    get roaming() {
        return this._data.roaming;
    }
    get customerService() {
        return this._data.customerService;
    }
    get published() {
        return !!this._data.published;
    }
    get isTariffShown() {
        return !!this._data.isTariffShown;
    }
}
